import { createApi } from '@reduxjs/toolkit/query/react'

import { transportBaseQuery } from './baseQuery'
import { RESOURCE_SCOPE_TAG } from './tags'

/**
 * Типы тегов — `string`, а не union: пакеты добавляют свои типы
 * (`enhanceEndpoints({ addTagTypes })`) позже, чем создаётся baseApi, и
 * union сделал бы RootState приложения несовместимым с селекторами пакетных
 * endpoints. Опечатки в тегах закрывают константы пакетов (`PLATFORM_RESOURCE_TAG`).
 */
const BASE_TAG_TYPES: readonly string[] = [RESOURCE_SCOPE_TAG]

/**
 * ЕДИНСТВЕННЫЙ `createApi` нового клиента (R04, V03). Пакеты добавляют свои
 * endpoints через `baseApi.injectEndpoints` с префиксом пакета (`platform*`,
 * `onec*`, `aqsi*`) и свои типы тегов через `enhanceEndpoints({ addTagTypes })`.
 * Второй `createApi` — ошибка eslint и арх-теста: два кэша значат два reducer,
 * два middleware и данные, которые не сбрасываются при выходе.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: transportBaseQuery,
  tagTypes: BASE_TAG_TYPES,
  endpoints: () => ({}),
  // Свежесть — по запросу экрана, а не таймером: окно, вернувшееся из вкладки,
  // перечитывает данные, а не показывает час назад полученный список.
  refetchOnMountOrArgChange: 30,
  keepUnusedDataFor: 60,
})

export type BaseApi = typeof baseApi
